import { render, staticRenderFns } from "./ReversalModal.vue?vue&type=template&id=65c97e79&scoped=true&"
import script from "./ReversalModal.vue?vue&type=script&lang=js&"
export * from "./ReversalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c97e79",
  null
  
)

export default component.exports